

export class AddressUtil {
    estadosBrasil = [
      { inputId: "AC", label: 'Acre', data: 'AC' },
      { inputId: "AL", label: 'Alagoas', data: 'AL' },
      { inputId: "AP", label: 'Amapá', data: 'AP' },
      { inputId: "AM", label: 'Amazonas', data: 'AM' },
      { inputId: "BA", label: 'Bahia', data: 'BA' },
      { inputId: "CE", label: 'Ceará', data: 'CE' },
      { inputId: "DF", label: 'Distrito Federal', data: 'DF' },
      { inputId: "ES", label: 'Espírito Santo', data: 'ES' },
      { inputId: "GO", label: 'Goiás', data: 'GO' },
      { inputId: "MA", label: 'Maranhão', data: 'MA' },
      { inputId: "MT", label: 'Mato Grosso', data: 'MT' },
      { inputId: "MS", label: 'Mato Grosso do Sul', data: 'MS' },
      { inputId: "MG", label: 'Minas Gerais', data: 'MG' },
      { inputId: "PA", label: 'Pará', data: 'PA' },
      { inputId: "PB", label: 'Paraíba', data: 'PB' },
      { inputId: "PR", label: 'Paraná', data: 'PR' },
      { inputId: "PE", label: 'Pernambuco', data: 'PE' },
      { inputId: "PI", label: 'Piauí', data: 'PI' },
      { inputId: "RJ", label: 'Rio de Janeiro', data: 'RJ' },
      { inputId: "RN", label: 'Rio Grande do Norte', data: 'RN' },
      { inputId: "RS", label: 'Rio Grande do Sul', data: 'RS' },
      { inputId: "RO", label: 'Rondônia', data: 'RO' },
      { inputId: "RR", label: 'Roraima', data: 'RR' },
      { inputId: "SC", label: 'Santa Catarina', data: 'SC' },
      { inputId: "SP", label: 'São Paulo', data: 'SP' },
      { inputId: "SE", label: 'Sergipe', data: 'SE' },
      { inputId: "TO", label: 'Tocantins', data: 'TO' }
    ];
  }